import { FormattedMessage } from 'react-intl';

export function EditorTitle() {
  return (
    <div
      style={{
        fontWeight: '500',
        fontSize: '20px',
      }}
      data-testid="editor-title"
    >
      <FormattedMessage id="jointFragments.editorScreen.title" defaultMessage="Editor" />
    </div>
  );
}
